import React from 'react'
import { Layout, Button, Dropdown, Menu, Avatar, Drawer } from 'antd'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
  LogoutOutlined,
  UserOutlined,
  LockOutlined,
  MenuOutlined,
  ArrowLeftOutlined,
  AppstoreOutlined,
  DatabaseOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  AuditOutlined,
} from '@ant-design/icons'
import menuActions from 'redux/menu/actions'
import filterMenuByPermissions from 'services/menu/menuPermissionFilter'

const { SubMenu } = Menu

const CUSTOMER_ONLY_SLUGS = [
  'customer_view',
  'customer_dashboard',
  'customer_wo_request',
  'customer_proposal_request',
  'customer_proposal_approve',
  'proposal_budget_approval',
]

const mapStateToProps = ({ user, settings, menu }) => ({
  user,
  settings,
  menuContract: menu.menuContract || [],
  menuBasicData: menu.menuBasicData || [],
  menuReport: menu.menuReport || [],
  menuSettings: menu.menuData5 || [],
  menuQuality: menu.menuData6 || [],
})

@withRouter
@connect(mapStateToProps)
@injectIntl
class CustomerLayout extends React.PureComponent {
  state = {
    drawerVisible: false,
    menusFetched: false,
  }

  componentDidMount() {
    if (this.hasBackofficePermissions()) {
      this.fetchMenus()
    }
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props
    const { menusFetched } = this.state
    if (prevProps.user.permissions !== user.permissions && this.hasBackofficePermissions()) {
      if (!menusFetched) {
        this.fetchMenus()
      }
    }
  }

  fetchMenus = () => {
    const { dispatch } = this.props
    dispatch({ type: menuActions.GET_CONTRACT_MENU })
    dispatch({ type: menuActions.GET_BASICDATA_MENU })
    dispatch({ type: menuActions.GET_REPORT_MENU })
    dispatch({ type: menuActions.GET_SETTING_MENU })
    dispatch({ type: menuActions.GET_QUALITYCONTROL_MENU })
    this.setState({ menusFetched: true })
  }

  hasBackofficePermissions = () => {
    const { user } = this.props
    const permissions = user.permissions || []
    return permissions.some(p => {
      const slug = typeof p === 'string' ? p : p?.slug
      return slug && !CUSTOMER_ONLY_SLUGS.includes(slug)
    })
  }

  getFilteredItems = (menuItems) => {
    const { user } = this.props
    const permissions = user.permissions || []
    const isCustomerPortalUser = permissions.some(p => {
      const slug = typeof p === 'string' ? p : p?.slug
      return slug === 'customer_dashboard'
    })
    const filtered = filterMenuByPermissions(menuItems, permissions)
    // Remove separators and hide WO/Proposal for customer portal users (they have their own)
    const hiddenForCustomer = ['workorderlist', 'proposals', 'proposalApprovementList']
    return filtered.filter(item => {
      if (item.key === 'seperator' || !item.url) return false
      if (isCustomerPortalUser && hiddenForCustomer.includes(item.key)) return false
      return true
    })
  }

  renderMenuItems = (items) => {
    const { intl } = this.props
    return items.map(item => {
      if (item.children && item.children.length > 0) {
        const filteredChildren = this.getFilteredItems(item.children)
        if (filteredChildren.length === 0) return null
        return (
          <SubMenu
            key={item.key}
            title={intl.formatMessage({ id: item.key, defaultMessage: item.key })}
          >
            {filteredChildren.map(child => (
              <Menu.Item key={child.key}>
                <Link to={child.url}>
                  {child.icon && <i className={`${child.icon} mr-2`} />}
                  <FormattedMessage id={child.key} defaultMessage={child.key} />
                </Link>
              </Menu.Item>
            ))}
          </SubMenu>
        )
      }
      return (
        <Menu.Item key={item.key}>
          <Link to={item.url}>
            {item.icon && <i className={`${item.icon} mr-2`} />}
            <FormattedMessage id={item.key} defaultMessage={item.key} />
          </Link>
        </Menu.Item>
      )
    })
  }

  render() {
    const {
      children,
      user,
      dispatch,
      history,
      menuContract,
      menuBasicData,
      menuReport,
      menuSettings,
      menuQuality,
    } = this.props
    const { drawerVisible } = this.state

    const handleLogout = () => {
      dispatch({ type: 'user/LOGOUT' })
    }

    const handleChangePassword = () => {
      history.push('/customer/change-password')
    }

    const userMenu = (
      <Menu>
        <Menu.Item key="password" onClick={handleChangePassword}>
          <LockOutlined style={{ marginRight: 8 }} />
          <FormattedMessage id="customer.password.changePassword" />
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="logout" onClick={handleLogout}>
          <LogoutOutlined style={{ marginRight: 8 }} />
          <FormattedMessage id="logout" />
        </Menu.Item>
      </Menu>
    )

    const hasBackoffice = this.hasBackofficePermissions()
    const filteredContract = this.getFilteredItems(menuContract)
    const filteredBasicData = this.getFilteredItems(menuBasicData)
    const filteredReport = this.getFilteredItems(menuReport)
    const filteredSettings = this.getFilteredItems(menuSettings)
    const filteredQuality = this.getFilteredItems(menuQuality)

    return (
      <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
        <Layout.Header
          style={{
            background: '#fff',
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
            zIndex: 10,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {hasBackoffice && (
              <MenuOutlined
                onClick={() => this.setState({ drawerVisible: true })}
                style={{
                  fontSize: 20,
                  color: '#001529',
                  cursor: 'pointer',
                  marginRight: 16,
                  padding: 4,
                }}
              />
            )}
            <img
              src="/resources/images/protec-logo.png"
              alt="Protec CMS"
              style={{ height: 36 }}
            />
            <span
              style={{
                marginLeft: 12,
                padding: '2px 10px',
                background: '#001529',
                borderRadius: 4,
                fontSize: 12,
                color: '#fff',
              }}
            >
              <FormattedMessage id="customerPortal" />
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            {history.location.pathname !== '/customer/dashboard' && (
              <Button
                type="default"
                icon={<ArrowLeftOutlined />}
                onClick={() => history.push('/customer/dashboard')}
                style={{ fontWeight: 500, color: '#001529', borderColor: '#001529' }}
              >
                <FormattedMessage id="customer.backToDashboard" defaultMessage="Back to Dashboard" />
              </Button>
            )}
            {history.location.pathname === '/customer/dashboard' && (
              <Button
                type="link"
                onClick={() => history.push('/customer/dashboard')}
                style={{ fontWeight: 500, color: '#001529' }}
              >
                <FormattedMessage id="customerDashboard" />
              </Button>
            )}
            {(() => {
              const permissions = user.permissions || []
              const budgetPerm = permissions.find(p => (typeof p === 'string' ? p : p?.slug) === 'proposal_budget_approval')
              const budgetLimit = budgetPerm && typeof budgetPerm === 'object' ? parseFloat(budgetPerm.parameterValue) : 0
              if (budgetLimit > 0) {
                return (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 6,
                      padding: '4px 12px',
                      background: '#f6ffed',
                      border: '1px solid #b7eb8f',
                      borderRadius: 4,
                      fontSize: 12,
                    }}
                  >
                    <AuditOutlined style={{ color: '#52c41a', fontSize: 14 }} />
                    <span style={{ color: '#389e0d', fontWeight: 600 }}>
                      {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(budgetLimit)}
                    </span>
                  </div>
                )
              }
              return null
            })()}
            <Dropdown overlay={userMenu} trigger={['click']}>
              <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
                <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: '#001529' }} />
                <span style={{ color: '#001529' }}>{user.name || user.userName}</span>
              </div>
            </Dropdown>
          </div>
        </Layout.Header>

        {hasBackoffice && (
          <Drawer
            title={
              <span style={{ color: '#fff', fontSize: 16, fontWeight: 600 }}>
                <AppstoreOutlined style={{ marginRight: 8 }} />
                <FormattedMessage id="navigation" defaultMessage="Navigation" />
              </span>
            }
            placement="left"
            onClose={() => this.setState({ drawerVisible: false })}
            visible={drawerVisible}
            bodyStyle={{ padding: 0, background: '#001529' }}
            headerStyle={{ background: '#001529', borderBottom: '1px solid #1890ff' }}
            width={280}
            closable
            closeIcon={<span style={{ color: '#fff' }}>✕</span>}
          >
            <Menu
              theme="dark"
              mode="inline"
              style={{ borderRight: 0 }}
              onClick={() => this.setState({ drawerVisible: false })}
            >
              {/* Customer Portal Home */}
              <Menu.Item key="portal-home" icon={<UserOutlined />}>
                <Link to="/customer/dashboard">
                  <FormattedMessage id="customerDashboard" />
                </Link>
              </Menu.Item>

              <Menu.Divider style={{ borderColor: '#1890ff', margin: '8px 0' }} />

              {/* Operations */}
              {filteredContract.length > 0 && (
                <SubMenu
                  key="operations"
                  icon={<AppstoreOutlined />}
                  title={<FormattedMessage id="operations" defaultMessage="Operations" />}
                >
                  {this.renderMenuItems(filteredContract)}
                </SubMenu>
              )}

              {/* Basic Data */}
              {filteredBasicData.length > 0 && (
                <SubMenu
                  key="basicdata"
                  icon={<DatabaseOutlined />}
                  title={<FormattedMessage id="basicData" defaultMessage="Basic Data" />}
                >
                  {this.renderMenuItems(filteredBasicData)}
                </SubMenu>
              )}

              {/* Reports */}
              {filteredReport.length > 0 && (
                <SubMenu
                  key="reports"
                  icon={<BarChartOutlined />}
                  title={<FormattedMessage id="reports" defaultMessage="Reports" />}
                >
                  {this.renderMenuItems(filteredReport)}
                </SubMenu>
              )}

              {/* Quality Control */}
              {filteredQuality.length > 0 && (
                <SubMenu
                  key="quality"
                  icon={<SafetyCertificateOutlined />}
                  title={<FormattedMessage id="qualityControl" defaultMessage="Quality Control" />}
                >
                  {this.renderMenuItems(filteredQuality)}
                </SubMenu>
              )}

              {/* Settings */}
              {filteredSettings.length > 0 && (
                <SubMenu
                  key="settings"
                  icon={<SettingOutlined />}
                  title={<FormattedMessage id="settings" defaultMessage="Settings" />}
                >
                  {this.renderMenuItems(filteredSettings)}
                </SubMenu>
              )}
            </Menu>
          </Drawer>
        )}

        <Layout.Content style={{ padding: '24px', minHeight: 'calc(100vh - 134px)' }}>
          {children}
        </Layout.Content>
        <Layout.Footer style={{ textAlign: 'center', background: '#f0f2f5' }}>
          Protec CMS &copy; {new Date().getFullYear()} — Softlare GmbH
        </Layout.Footer>
      </Layout>
    )
  }
}

export default CustomerLayout
